import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { Fragment } from "vue-fragment";
import { mapActions, mapGetters, mapState } from "vuex";
import DomainNotFoundOverlay from "./main/components/site-overlay/domain-not-found-overlay.vue";
import BrowserNotSupportedOverlay from "@Shared/components/general/browser-not-supported-overlay.vue";
import { browserNotRecommended, browserNotSupported } from "@Shared/@Utils/utils";
import cssVars from "css-vars-ponyfill";
import BrowserNotRecommendedOverlay from "./main/components/site-overlay/browser-not-recommended-overlay.vue";
import { CHECK_SUBDOMAIN } from "./main/store/account/account-actions";
import numeral from "numeral";
import { GLOBAL_MAINTENANCE_IN_PROGRESS } from "./status-page/store/status-page-getters";
import { EXTERNAL_SERVICE_NAME } from "@Shared/@Types/status-page/types";
import { MAINTENANCE_MODE_INTERVAL_MS } from "@Shared/js/constants";
import { LOAD_EXTERNAL_SERVICES_STATUS } from "./status-page/store/status-page-actions";
import { SESSION_TOKEN } from "./application-standalone/store/application-standalone-getters";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "App",
  components: {
    Fragment,
    DomainNotFoundOverlay,
    BrowserNotSupportedOverlay,
    BrowserNotRecommendedOverlay
  },
  data() {
    return {
      showSubdomainOverlay: false,
      isSupportedBrowser: true,
      isRecommendedBrowser: true,
      checkIfMaintenanceInterval: null
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", {
    token: "token",
    localeLanguage(state) {
      return state.accountDetails.localeLanguage;
    }
  })), mapGetters("StatusPageStore", [GLOBAL_MAINTENANCE_IN_PROGRESS])), mapGetters("ApplicationStandaloneStore", [SESSION_TOKEN])), {}, {
    preferredLocale() {
      let navigatorLocale = "en-CA";
      if (/^fr\b/.test(navigator.language)) {
        navigatorLocale = "fr-CA";
      }
      return this.token || this.SESSION_TOKEN ? this.localeLanguage : navigatorLocale;
    },
    rawLocale() {
      return this.preferredLocale.replace("-CA", "");
    }
  }),
  watch: {
    preferredLocale: {
      immediate: true,
      handler(locale) {
        this.$root.$i18n.locale = locale;
      }
    },
    "$root.$i18n.locale": {
      immediate: true,
      handler(locale) {
        this.configurePluginsLocale(locale.replace("-CA", ""));
      }
    },
    [GLOBAL_MAINTENANCE_IN_PROGRESS](globalMaintenanceInProgress) {
      if (globalMaintenanceInProgress) {
        this.stopCheckingForMaintenance();
        this.$router.replace({
          name: "maintenance-message"
        });
      }
    }
  },
  async beforeMount() {
    await this.CHECK_SUBDOMAIN().catch(() => {
      this.showSubdomainOverlay = true;
    });
  },
  beforeDestroy() {
    this.stopCheckingForMaintenance();
  },
  mounted() {
    this.$auth.init(this);
    this.$socket.init(this.$auth);
    this.checkUnsupportedBrowsers();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("AccountStore", [CHECK_SUBDOMAIN])), mapActions("StatusPageStore", [LOAD_EXTERNAL_SERVICES_STATUS])), {}, {
    configurePluginsLocale(rawLocale) {
      $.fn.datepicker.defaults.language = rawLocale;
      $.fn.select2.defaults.set("language", rawLocale);
      moment.locale(rawLocale);
      window.Parsley.setLocale(rawLocale);
      numeral.locale(rawLocale === "fr" ? "fr-ca" : rawLocale);
    },
    checkUnsupportedBrowsers() {
      this.isSupportedBrowser = !browserNotSupported("client");
      this.isRecommendedBrowser = !browserNotRecommended();
      if (!this.isRecommendedBrowser) {
        cssVars({
          watch: true,
          silent: true
        });
      }
    },
    async checkForMaintenance() {
      await this.LOAD_EXTERNAL_SERVICES_STATUS(EXTERNAL_SERVICE_NAME.GLOBAL);
    },
    startCheckingForMaintenance() {
      this.stopCheckingForMaintenance();
      this.checkIfMaintenanceInterval = setInterval(() => {
        this.checkForMaintenance();
      }, MAINTENANCE_MODE_INTERVAL_MS); //every 5 min
    },
    stopCheckingForMaintenance() {
      if (this.checkIfMaintenanceInterval) {
        clearInterval(this.checkIfMaintenanceInterval);
      }
    }
  })
});